import * as jsvat from '@accountable/jsvat';
import { checkVAT } from '@accountable/jsvat';
import Joi from 'joi';
import { AccountSettingsFieldsNamesEnum } from 'types/settings.types';
import { AvailableCountries } from 'types/users.types';
import { settingsErrorMessagesFormatter } from 'utils/settings/settingsHelpers';
import { groupValidation } from 'validation/commonValidators';

const BEOnboardingFormSchema = () =>
  Joi.object({
    [AccountSettingsFieldsNamesEnum.VATNumber]: Joi.string()
      .required()
      .custom((value, helpers) => {
        const { isValid } = checkVAT(value, [jsvat.belgium]);

        if (!isValid) {
          return helpers.error('any.invalid');
        }
        return value;
      })
      .messages(
        settingsErrorMessagesFormatter(
          AccountSettingsFieldsNamesEnum.VATNumber,
        ),
      ),
    [AccountSettingsFieldsNamesEnum.APC1]: Joi.string().required(),
    [AccountSettingsFieldsNamesEnum.APC2]: Joi.string().required(),
    [AccountSettingsFieldsNamesEnum.monthlyPaymentVolume]:
      Joi.string().required(),
    ...groupValidation(AccountSettingsFieldsNamesEnum.address, {
      [AccountSettingsFieldsNamesEnum.street]: Joi.string()
        .required()
        .messages(
          settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.street),
        ),
      [AccountSettingsFieldsNamesEnum.city]: Joi.string()
        .required()
        .messages(
          settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.city),
        ),
      [AccountSettingsFieldsNamesEnum.zip]: Joi.string()
        .required()
        .length(4)
        .messages(
          settingsErrorMessagesFormatter(
            `${AccountSettingsFieldsNamesEnum.zip}.be`,
          ),
        ),
    }),
  });

const DEOnboardingFormSchema = () =>
  Joi.object({
    [AccountSettingsFieldsNamesEnum.steuernummer]: Joi.when(
      AccountSettingsFieldsNamesEnum.state,
      {
        is: Joi.string().exist(),
        then: Joi.required().when(Joi.ref('/country'), {
          is: AvailableCountries.germany,
          then: Joi.custom((value, helpers) => {
            const values = helpers.state.ancestors[0];

            if (values.steuernummerValid === false) {
              return helpers.error('any.invalid');
            }
            return value;
          }).messages(
            settingsErrorMessagesFormatter(
              AccountSettingsFieldsNamesEnum.steuernummer,
            ),
          ),
        }),
      },
    ),
    [AccountSettingsFieldsNamesEnum.APC1]: Joi.string().required(),
    [AccountSettingsFieldsNamesEnum.APC2]: Joi.string().required(),
    [AccountSettingsFieldsNamesEnum.monthlyPaymentVolume]:
      Joi.string().required(),
    ...groupValidation(AccountSettingsFieldsNamesEnum.address, {
      [AccountSettingsFieldsNamesEnum.street]: Joi.string()
        .required()
        .messages(
          settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.street),
        ),
      [AccountSettingsFieldsNamesEnum.city]: Joi.string()
        .required()
        .messages(
          settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.city),
        ),
      [AccountSettingsFieldsNamesEnum.zip]: Joi.string()
        .required()
        .length(5)
        .messages(
          settingsErrorMessagesFormatter(
            `${AccountSettingsFieldsNamesEnum.zip}.de`,
          ),
        ),
      [AccountSettingsFieldsNamesEnum.state]: Joi.string()
        .required()
        .messages(
          settingsErrorMessagesFormatter(AccountSettingsFieldsNamesEnum.state),
        ),
    }),
  });

export { DEOnboardingFormSchema, BEOnboardingFormSchema };
